import React from 'react';
import { ContentScheme } from '../../common/helpers/contentScheme/ContentScheme';

export const AccessDeniedPage = () => {
  return (
    <>
        <ContentScheme >
          <h1
          style={{
            width:'100%',
            textAlign: 'center',
            marginBottom: '5px',
            fontSize: '22px',
            fontWeight: 'normal'
          }}
          >У вас недостаточно прав для доступа к этой странице.</h1>
<h3 style={{
            width:'100%',
            textAlign: 'center',
            marginBottom: '20px',
            fontSize: '16px',
            fontWeight: 'normal'
          }}>Пожалуйста, свяжитесь с администратором, <br/>если считаете, что это ошибка.</h3>
        </ContentScheme>
    </>
  )
}